/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideJustification } from './OverrideJustification';
import {
  OverrideJustificationFromJSON,
  OverrideJustificationFromJSONTyped,
  OverrideJustificationToJSON,
} from './OverrideJustification';

/**
 *
 * @export
 * @interface PaginatedOverrideJustificationList
 */
export interface PaginatedOverrideJustificationList {
  /**
   *
   * @type {number}
   * @memberof PaginatedOverrideJustificationList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedOverrideJustificationList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedOverrideJustificationList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<OverrideJustification>}
   * @memberof PaginatedOverrideJustificationList
   */
  results: Array<OverrideJustification>;
}

/**
 * Check if a given object implements the PaginatedOverrideJustificationList interface.
 */
export function instanceOfPaginatedOverrideJustificationList(
  value: object,
): value is PaginatedOverrideJustificationList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedOverrideJustificationListFromJSON(json: any): PaginatedOverrideJustificationList {
  return PaginatedOverrideJustificationListFromJSONTyped(json, false);
}

export function PaginatedOverrideJustificationListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedOverrideJustificationList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(OverrideJustificationFromJSON),
  };
}

export function PaginatedOverrideJustificationListToJSON(value?: PaginatedOverrideJustificationList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(OverrideJustificationToJSON),
  };
}
